import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import './modal.scss'; // your custom styles
import { closeMouseEvent } from '../../../actions/uiAction';

const ExitIntentModal = (props) => {
  const settingsData = useSelector((state) => state.subscriptionData.settingData);

     const dateCal = (futureDate) => {
      const today = new Date();
      const future = new Date(futureDate); // Ensure it's a Date object

      const diffMs = future - today;
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24)); // round up to include partial days

      // Convert to months (based on 30-day blocks)
      const months = Math.floor(diffDays / 30);
      if (diffDays && diffDays < 30) {
         return `${diffDays} Days`;
      } else {
         return `${months} Months`;
      }
   };
  const offerOn = settingsData && settingsData.offerStatus && settingsData.offerStatus === 1 ? true : false;
   const isPackageOffer = offerOn && settingsData.packagediscountStatus && settingsData.packagediscountStatus === 1 ? true : false;
   const isTrailOffer = offerOn && settingsData.trialStatus && settingsData.trialStatus === 1 ? true : false;
      const packageDiscount = isPackageOffer && settingsData.packageDiscountPercent ? settingsData.packageDiscountPercent : 0;
   const trailDiscount =
      isTrailOffer && settingsData.trialPeriod
         ? settingsData.trialPeriod === 'custom date'
            ? dateCal(settingsData?.trialExpiry)
            : settingsData.trialPeriod
         : '';

const dispatch = useDispatch();
  return (
    <Modal isOpen={true} toggle={()=> dispatch(closeMouseEvent())} backdrop="static" centered className="exit-intent-modal">
      <ModalHeader toggle={()=> dispatch(closeMouseEvent())} >
        WAIT — Don’t Miss Your {isPackageOffer ? `${packageDiscount}%` : isTrailOffer ? `${trailDiscount}` : ''} Saving
      </ModalHeader>
      <ModalBody>
        <p>
          You were just steps away from unlocking <strong>{isPackageOffer ? `${packageDiscount}%` : isTrailOffer ? `${trailDiscount}` : ''} off your Cloudoc policy pack licence</strong> —
          fully compliant, always up-to-date, and ready to use.
        </p>
        <ul className="list-unstyled mb-3">
          <li>🎯 <strong>Instant access</strong></li>
          <li>🛡️ <strong>Regulator-ready</strong></li>
          <li>💷 <strong>Best price — now even better</strong></li>
        </ul>
        <Button color="success" className="w-100 fw-bold" onClick={() => {dispatch(closeMouseEvent());props.history.push({ pathname: '/policies-procedures', state: { country: 'england' } })}}>
          📥 Get your documents now
        </Button>
        <div className="text-center mt-2">
          <small className="text-muted">Offer ends soon — don’t miss out.</small>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ExitIntentModal;
